import { useMemo } from 'react';
import { audit } from '~/infra/utils';
import { PusherEvent, useBusinessChannelEvent } from '~/pusher';
import { useAppConfig, useStoreActions } from '~/store/store-context';
export function useInAppNotificationsBinder() {
    const { fetchInAppNotifications } = useStoreActions();
    const { inAppNotificationsAuditIntervalMs } = useAppConfig();
    const fetchInAppNotificationsAudit = useMemo(()=>audit(fetchInAppNotifications, inAppNotificationsAuditIntervalMs), []);
    useBusinessChannelEvent({
        source: 'mgmt',
        eventName: PusherEvent.MailboxUpdated,
        callback: ()=>void fetchInAppNotificationsAudit(),
        onBind: ()=>void fetchInAppNotifications()
    });
}
